import { createContext, useContext, useState } from 'react';

const SidebarContextType = {
    refreshTrigger: 0,
    triggerRefresh: () => { },
}

const SidebarContext = createContext(SidebarContextType);

export const SidebarProvider = ({ children }) => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const triggerRefresh = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <SidebarContext.Provider
            value={{
                refreshTrigger,
                triggerRefresh,
            }}
        >
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebarContext = () => {
    const context = useContext(SidebarContext);
    if (context === undefined) {
        throw new Error('useSidebarContext must be used within a SidebarProvider');
    }
    return context;
}; 